import React from "react"
import Link from "gatsby-link"
import Helmet from "react-helmet"

import MasterLayout from "./master"

class CalcPageLayout extends React.Component {
  render() {
    let siteMetadata = this.props.data.site.siteMetadata

    return (
      <MasterLayout {...this.props}>
        <div className="section">
          {this.props.children()}
        </div>
        <div className="section">
          <hr />
          <div className="container">
            <p>
              {siteMetadata.siteDescr}
              <a href={siteMetadata.siteTwitterUrl}>
                <br /> <strong>{siteMetadata.siteAuthor}</strong> on Twitter
              </a>
            </p>
          </div>
        </div>
      </MasterLayout>
    )
  }
}

export default CalcPageLayout

export const pageQuery = graphql`
query CalcPageLayoutBySlug {
  site {
    siteMetadata {
      siteTitle
      siteDescr
      siteAuthor
      siteEmail
      siteTwitterUrl
      siteTwitterPretty
    }
  }
}
`



// WEBPACK FOOTER //
// ./src/layouts/calcPage.js